import { z } from "zod";

export const schema = z.object({
  email: z
    .string({ required_error: "Email atau username harus diisi" })
    .min(1, "Email atau username harus diisi"),
  password: z
    .string({ required_error: "Kata sandi harus diisi" })
    .regex(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[A-Za-z\d !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,}$/,
      "Kata sandi minimal 8 karakter dengan kombinasi huruf, angka, dan karakter khusus",
    ),
});

export type LoginSchema = z.infer<typeof schema>;
